import * as React from "react";
import { Drawer } from "components/common";
import { Col } from "common/components/layout-styles";
import EventDetails from "security-app/components/SecurityEvents/Alerts/EventDetails";
const SecurityEventDetails = ({ secEvent, onClose }) => {
  var _a;
  return /* @__PURE__ */ React.createElement(Drawer, { onClose, size: "lg", title: (_a = secEvent == null ? void 0 : secEvent.event) == null ? void 0 : _a.message, parentSize: "lg", parentPosition: "right", level: 1 }, /* @__PURE__ */ React.createElement(Col, { $align: "stretch" }, /* @__PURE__ */ React.createElement(EventDetails, { securityEventId: secEvent.event_id, orientation: "vert" })));
};
export default SecurityEventDetails;
